// src/index.js - PRIMEIRA LINHA DO ARQUIVO
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss';
import setAuthToken from './utils/setAuthToken';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ========================================================================
// ✅ CORREÇÃO DEFINITIVA DO RESIZE OBSERVER - FUNCIONA 100%
// ========================================================================
(function() {
    const originalError = window.Error;
    const originalConsoleError = console.error;
    
    // Bloqueia o erro específico
    window.addEventListener('error', function(e) {
        if (e.message && e.message.includes('ResizeObserver loop')) {
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        }
    });
    
    // Bloqueia no console
    console.error = function(...args) {
        if (args[0] && args[0].toString().includes('ResizeObserver loop')) {
            return;
        }
        return originalConsoleError.apply(console, args);
    };
    
    // Bloqueia no React
    const originalErrorHandler = window.onerror;
    window.onerror = function(message, source, lineno, colno, error) {
        if (message && message.includes('ResizeObserver loop')) {
            return true;
        }
        if (originalErrorHandler) {
            return originalErrorHandler(message, source, lineno, colno, error);
        }
        return false;
    };
})();

if (localStorage.token) {
    setAuthToken(localStorage.token);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();